import React from 'react';
import { Sentry } from '@/common/utils/sentry';

class SentryErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setTag('errorBoundary', true);
      scope.setContext('errorInfo', errorInfo);
      Sentry.captureException(error);
    });
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#f5f5f5',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            margin: '20px',
          }}
        >
          <h2>Oops! Une erreur est survenue</h2>
          <p>
            Une erreur inattendue s'est produite. Notre équipe a été notifiée.
          </p>
          <details style={{ marginTop: '10px', textAlign: 'left' }}>
            <summary>Détails de l'erreur (cliquez pour voir)</summary>
            <pre
              style={{
                backgroundColor: '#fff',
                padding: '10px',
                marginTop: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '12px',
                overflow: 'auto',
              }}
            >
              {this.state.error?.message || 'Erreur inconnue'}
            </pre>
          </details>
          <button
            onClick={this.resetError}
            style={{
              marginTop: '10px',
              padding: '8px 16px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Essayer de nouveau
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default SentryErrorBoundary;
